import { MasterTranslation } from '@/constants';
import { useGlobalState, useStatsigLayer } from '@/hooks';

export const useTrackingWidgetCopy = () => {
  const { t, isLoggedIn } = useGlobalState();
  const { getEnglishOnlyText: getAnonymousEnglishOnlyText, isReady: isAnonymousReady } =
    useStatsigLayer('track_my_parcel_copy_layer');
  const { getEnglishOnlyText: getSignedInEnglishOnlyText, isReady: isSignedInReady } = useStatsigLayer(
    'track_my_parcel_signed_in_layer',
  );

  const fallback = {
    addParcels: t(MasterTranslation.AddParcels),
    placeholder: t(MasterTranslation.TrackingWidget),
  };

  if (!isAnonymousReady || !isSignedInReady) return fallback;

  const getEnglishOnlyText = isLoggedIn ? getSignedInEnglishOnlyText : getAnonymousEnglishOnlyText;

  return {
    addParcels: getEnglishOnlyText('add_parcels', fallback.addParcels),
    placeholder: getEnglishOnlyText('tracking_widget_placeholder', fallback.placeholder),
  };
};
